export const getApiEnv = function () {
  let hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!hostname) {
    return 'prod';
  }
  if (hostname === 'localhost') {
    return 'localhost';
  }
  if (hostname.includes('-dev-ecs.components.product.which.co.uk') || hostname === 'dev-deliver.components.product.which.co.uk' || hostname === 'dev.internal.which.co.uk') {
    return 'dev';
  }
  if (hostname === 'test-deliver.components.product.which.co.uk' || hostname === 'test.internal.which.co.uk') {
    return 'test';
  }
  if (hostname === 'qa-deliver.components.product.which.co.uk') {
    return 'qa';
  }
  if (hostname === 'preprod-deliver.components.product.which.co.uk' || hostname === 'preprod.internal.which.co.uk') {
    return 'preprod';
  }
  return 'prod';
};